import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'row',
    width: '100%',
    rowGap: '20px',
  },
  titleWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    flexGrow: 1,
  },
  title: {
    color: theme.palette.green,
    fontWeight: 'bold',
    width: 250,
  },
  button: {
    backgroundColor: theme.palette.green,
    color: 'white',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: theme.palette.green,
      boxShadow: 'none',
    },
  },
  searchBar: {
    width: 'auto',
    border: '1px solid #15B5B3',
    display: 'inline-block',
    boxShadow: 'none',
    backgroundColor: 'transparent',
    '& button': {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
    },
    '& input': {
      paddingLeft: theme.spacing(1),
      color: theme.palette.green,
    },
  },
  iconButton: {
    color: theme.palette.green,
  },
}))

export default useStyles
